// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GaS6","colBig":"styles_colBig__37sXZ","colSmall":"styles_colSmall__3cZKl"};